import { z } from "zod";

export const ClientFileReportType = z.enum(["benchmark", "budget"]);

export const ClientFileReport = z.object({
    id: z.number(),
    authorId: z.number(),
    type: ClientFileReportType,
    author: z
        .object({
            avatar: z.string().nullish(),
            name: z.string().nullish(),
        })
        .nullable(),
    embeddedFiles: z.array(z.string()),
    title: z.string().nullish(),
    description: z.string().nullish(),
});
